import { useQuery } from "react-query";
import { MetaInsightsService } from "../../../services/meta/metaInsights.service";
export var useInsightFilterOptions = function () {
    return useQuery('insightFilterOptions', MetaInsightsService.getInsightFilterOptions, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
